import { useContext, useMemo } from 'react';
import { cloneDeep, merge } from 'lodash';

import { CRM_IDENTITY } from '../../products';
import { WebsiteDataContext } from './useWebsiteData';

export const useCRMData = () => {
    const { crm } = useContext(WebsiteDataContext);

    return useMemo(() => merge(cloneDeep(CRM_IDENTITY), crm), [crm]);
};
